var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHuman(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "1.15 0 13.71 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 49374"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.499 1.5a1.5 1.5 0 1 1-1.5-1.5 1.5 1.5 0 0 1 1.5 1.5Z",
    "data-name": "Path 46490"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 3.5H2a.894.894 0 0 0 0 1.786h3.517a.762.762 0 0 1 .614.528 4.6 4.6 0 0 1-.018 1.924l-.136.8a.014.014 0 0 1 0 .011l-1.089 6.404a.891.891 0 0 0 .7 1.034.853.853 0 0 0 .986-.726l.75-4.461v.007s.221-1.209.661-1.209h.039c.447 0 .661 1.209.661 1.209l.75 4.461a.858.858 0 0 0 .989.722.889.889 0 0 0 .693-1.034l-1.086-6.408a.014.014 0 0 0 0-.011l-.136-.8a4.6 4.6 0 0 1-.018-1.924.762.762 0 0 1 .614-.528h3.515a.894.894 0 0 0 0-1.786Z",
    "data-name": "Path 46491"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h16v16H0z",
    "data-name": "Rectangle 16220"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHuman);
export default __webpack_public_path__ + "static/media/human.08d2df05c42f8dd4af5d6d37e1574626.svg";
export { ForwardRef as ReactComponent };